export function createAction(type, payload) {
    var action = payload === undefined ? { type: type } : { type: type, payload: payload };
    return action;
}
//# sourceMappingURL=actions.js.map